<template>
	<div id="form-establishment">
		<h2>
			<span>Editar Informaçoes do Establecimento</span>
		</h2>
		<br>
		<b-container>
      <b-row>
        <b-col sm="4">
					<b-input-group prepend="Titulo" size="sm" class="mt-4">
						<b-form-input
							v-model="editingCache.title"
							v-validate.initial="'required'"
							type="text"
							name="title"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('title').length === 0">
            {{errors.first('title')}}
          </b-form-invalid-feedback>
      </b-col>
        <b-col sm="4">
      			<b-input-group prepend="Email" size="sm" class="mt-4">
						<b-form-input
							v-model="editingCache.email"
							v-validate.initial="'required'"
							type="text"
							name="email"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('email').length === 0">
            {{errors.first('email')}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
					<b-input-group prepend="Telefone" size="sm" class="mt-4">
						<b-form-input
							v-model="editingCache.phone"
							v-validate.initial="'required'"
							type="text"
							name="phone"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('phone').length === 0">
            {{errors.first('phone')}}
          </b-form-invalid-feedback>
      </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
					<b-input-group prepend="Descriçao" size="sm" class="mt-4">
						<b-form-input
							v-model="editingCache.description"
							v-validate.initial="'required'"
							type="text"
							name="description"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('description').length === 0">
            {{errors.first('description')}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col sm="6">
					<b-input-group prepend="Morada" size="sm" class="mt-4">
						<b-form-input
							v-model="editingCache.address"
							v-validate.initial="'required'"
							type="text"
							name="address"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('address').length === 0">
            {{errors.first('address')}}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
      			<b-input-group prepend="Hora de abertura" size="sm" class="mt-4">
						<b-form-input
							v-model="editingCache.openingHour"
							v-validate.initial="'required'"
							type="text"
							name="openingHour"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('openingHour').length === 0">
            {{errors.first('openingHour')}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col sm="6">
					<b-input-group prepend="Hora de fecho" size="sm" class="mt-4">
						<b-form-input
							v-model="editingCache.closingHour"
							v-validate.initial="'required'"
							type="text"
							name="closingHour"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('closingHour').length === 0">
            {{errors.first('closingHour')}}
          </b-form-invalid-feedback>
      </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group description="insira separado por virgulas ,">
					<b-input-group prepend="Imagens" size="sm" class="mt-4" >
						<b-form-input
							v-model="preImages"
							v-validate.initial="'required'"
							type="text"
							name="images"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('images').length === 0">
            {{errors.first('images')}}
          </b-form-invalid-feedback>
          </b-form-group>
        </b-col> 
        </b-row>
      <b-row>
        <b-col sm="4">
					<b-input-group prepend="Titulo do menu" size="sm" class="mt-4">
						<b-form-input
							v-model="editingCache.menuTitle"
							v-validate.initial="'required'"
							type="text"
							name="menuTitle"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('menuTitle').length === 0">
            {{errors.first('menuTitle')}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col sm="8">
					<b-input-group prepend="Descriçao do menu" size="sm" class="mt-4">
						<b-form-input
							v-model="editingCache.menuDescription"
							v-validate.initial="'required'"
							type="text"
							name="menuDescription"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('menuDescription').length === 0">
            {{errors.first('menuDescription')}}
          </b-form-invalid-feedback>
      </b-col>
        <b-col sm="12">
          <b-form-group description="insira separado por virgulas ,">
      			<b-input-group prepend="Imagens do menu" size="sm" class="mt-4">
						<b-form-input
							v-model="preMenuImages"
							v-validate.initial="'required'"
							type="text"
							name="menuImages"
							size="sm"
						/>
					</b-input-group>
					<b-form-invalid-feedback
						:state="errors.collect('menuImages').length === 0">
            {{errors.first('menuImages')}}
          </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
		</b-container>
		<br>
		<b-button
			variant="primary"
			@click=" updateEstablishment(editingCache.id)"
			:disabled="errors.count() > 0"
		>Submeter</b-button>
	</div>
</template>

<script>
import api from "../../api";
import { mapMutations, mapActions } from 'vuex';
export default {
	name: "formEstablishment",
	props: {
		establishment: { type: Object, required: true }
	},
	data() {
		return {
      preImages: '',
      preMenuImages: '',
			editingCache: {
        title: '',
        description: '',
        email: '',
        phone: '',
        images: '',
        address: '',
        openingHour: '',
        closingHour: '',
        menuTitle: '',
        menuImages: '',
        menuDescription: ''
			}
		};
  },
  mounted (){
    this.editingCache = Object.assign({}, this.establishment)
    this.preImages = this.establishment.images.join(',')
    this.preMenuImages = this.establishment.menuImages.join(',')
  },
	methods: {
    ...mapMutations(['showNotice']),
    ...mapActions(['refreshEvents','refreshInfo']),
		updateEstablishment(id) {
      this.editingCache.images = this.preImages.split(',')
      this.editingCache.menuImages = this.preMenuImages.split(',')
			api.updateEstablishment({ id: id }, this.editingCache).then( () => {
        this.refreshInfo()
        this.showNotice({newMessage: 'Informaçoes atualizadas',type: 'success'})
      })
		},
	}
};
</script>

<style lang='css'>
#new-establishment label {
	text-align: left;
}
.errors-list {
	color: red;
	list-style-type: none;
}
</style>



